import React, { useEffect, useState, useRef, useContext } from 'react';
import './styles.scss';
import { GlobalContext } from '../../../../providers/global-provider';
import { PortfolioManagementContext } from '../../../../providers/portfolio-management';
import { GlobalTabsKeysEnum } from '../../../../providers/models/custom-app-links';

type AutoUpdateTimerProps = {
  initialSeconds?: number;
  onUpdate: () => Promise<void>;
};

export const AutoUpdateTimer: React.FC<AutoUpdateTimerProps> = ({
  initialSeconds = 30,
  onUpdate,
}) => {
  const { portfolioCurrentTab, currentTab } = useContext(GlobalContext);
  const { setIsPortfolioLoading } = useContext(PortfolioManagementContext);
  const [secondsLeft, setSecondsLeft] = useState(initialSeconds);
  const [loading, setLoading] = useState(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const isActive =
    portfolioCurrentTab === 'SPOT_LADDER' && currentTab === GlobalTabsKeysEnum.portfolioManagement;

  useEffect(() => {
    if (!isActive || loading) return;

    intervalRef.current = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(intervalRef.current!);
          setIsPortfolioLoading(true);
          setLoading(true);
          onUpdate().finally(() => {
            setLoading(false);
            setIsPortfolioLoading(false);
            setSecondsLeft(initialSeconds);
          });
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [isActive, loading]);

  return (
    <div className="auto-update-timer">
      {loading ? '(updating...)' : `(auto-update in ${secondsLeft}s...)`}
    </div>
  );
};
